(function () {
    let options = {
        whatsapp: "+39 391 328 1081", // WhatsApp number
        company_logo_url: "//storage.getbutton.io/widget/90/906d/906d5e3de7a2446afa6e5f0b6288748a/logo.jpg", // URL of company logo (png, jpg, gif)
        greeting_message: "Richiedi informazioni, lascia il tuo nome e il tuo numero di cellulare e sarai ricontattato", // Text of greeting message
        call_to_action: "Richiedi informazioni", // Call to action
        button_color: "#FF6550", // Color of button
        position: "right", // Position may be 'right' or 'left'
        branding: false, // Show branding string
        mobile: true, // Mobile version enabled
        desktop: true, // Desktop version enabled
        greeting: true, // Greeting message enabled
        shift_vertical: 0, // Vertical position, px
        shift_horizontal: 0, // Horizontal position, px
        domain: "www.rsnewtechnology.com", // site domain
        key: "2OHUyBWFS5a9yDi8eGoTCA", // pro-widget key
    };
    let proto = document.location.protocol, host = "getbutton.io", url = proto + "//static." + host;
    let s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = url + '/widget-send-button/js/init.js';
    s.onload = function () {
        WhWidgetSendButton.init(host, proto, options);
    };
    let x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
})();

let navLinks = document.querySelectorAll("header nav a");
for (let link of navLinks) {
    link.addEventListener("click", smoothScroll);
}


function smoothScroll(event) {
    event.preventDefault();
    let href = this.getAttribute("href");
    document.querySelector(href).scrollIntoView({
        behavior: "smooth"
    });
}
